import {makeStyles} from "@material-ui/core/styles";
import {cardTitle} from "./material-dashboard-pro-react";

export default makeStyles((theme) => ({
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
}));